import React from 'react';
import cellPropTypes from './cellPropTypes';

function CellFullName({ user }) {
  return <div className="user-list__fullname">{user.fullName}</div>;
}

CellFullName.propTypes = cellPropTypes;
export default CellFullName;
